"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ = _interopRequireDefault(require("./.."));
var _Notification = require("../Notification/Notification");
var _reactDom = require("react-dom");
var _Animate = _interopRequireDefault(require("./Animate"));
var _react = _interopRequireDefault(require("react"));
require("./Toast.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const ToastNotification = _ref => {
  var _notification$title;
  let {
    notification,
    onDismiss,
    show
  } = _ref;
  if (!notification) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/(0, _reactDom.createPortal)( /*#__PURE__*/_react.default.createElement(_Animate.default, {
    show: show,
    from: {
      opacity: 0
    },
    to: {
      opacity: 1
    },
    exitAnimation: [{
      opacity: 1,
      transform: "translateY(0)"
    }, {
      opacity: 0,
      transform: "translateY(50px)"
    }],
    options: {
      duration: 200
    },
    className: "toast-animate"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "toast-notification"
  }, /*#__PURE__*/_react.default.createElement(_.default, {
    title: (_notification$title = notification.title) !== null && _notification$title !== void 0 ? _notification$title : _Notification.DefaultTitles[notification.type],
    actions: notification.actions,
    severity: notification.type,
    onDismiss: () => {
      onDismiss([notification]);
    },
    className: "u-no-margin--bottom",
    timestamp: notification.timestamp,
    titleElement: "div",
    role: "alert"
  }, notification.message))), document.body));
};
ToastNotification.propTypes = {
  onDismiss: _propTypes.default.func.isRequired,
  show: _propTypes.default.bool.isRequired
};
var _default = exports.default = ToastNotification;